import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AuthenticateDocument } from './AuthenticateDocument';
import External from './Comp/ExternalUser';
import MainLayout from './Comp/MainLayout';
import { MindMapContext } from './Context/contex';
import { hasCachedDocument } from './Utils/documentCache';

const IS_DEV_MODE = process.env.REACT_APP_DEV_MODE === 'true';

export default function App({ isExternal, isTemplateDocument = false }) {
  const [isAuthenticating, setIsAuthenticating] = useState(!IS_DEV_MODE);
  const { setIsTemplateDocument } = MindMapContext();
  const { documentId } = useParams();

  // Non-mutating check, safe during render. Caching applies to normal documents
  // only — never templates.
  const isDocumentCached = useMemo(
    () => !isTemplateDocument && hasCachedDocument(documentId),
    [documentId, isTemplateDocument]
  );

  useEffect(() => {
    setIsTemplateDocument(isTemplateDocument);
  }, []);


  if (isExternal) {
    return <External />;
  }

  if (IS_DEV_MODE) {
    return <MainLayout />;
  }

  // Cache hit: render the main layout immediately (no gating loader) while auth
  // re-validates in the background and seeds documentInfo from cache.
  if (isDocumentCached) {
    return (
      <>
        <AuthenticateDocument background />
        <MainLayout />
      </>
    );
  }

  if (isAuthenticating) { // isAuthenticating
    return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
  }

  return <MainLayout />;
}
